import FormattedMessage from 'I18n/components/FormattedMessage';
import UIHeader from 'UIComponents/layout/UIHeader';
import { PAGE_IDS } from '../../constants/pageConfigs';
import { useSelector } from '../../context/Redux';
import { isUngatedForLegacyBoardSelector } from '../../redux/selectors/auth';
import JitaUserArea from '../jita/JitaUserArea';
import CreateTaskButton from './CreateTaskButton';
import TableBoardIconSwitcher from './TableBoardIconSwitcher';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { getImportLink, getQueuesLink } from '../../utils/links';
import { useCanImportTasks, useIsJitaUser } from '../../hooks/auth';
import UIFlex from 'UIComponents/layout/UIFlex';
import { HeaderRecordCount } from './HeaderRecordCount';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function SavedViewsTasksHeader({
  pageId,
  tabs
}) {
  const isBoard = pageId === PAGE_IDS.LEGACY_BOARD;
  const isUngatedForLegacyBoard = useSelector(isUngatedForLegacyBoardSelector);
  const isJitaUser = useIsJitaUser();
  const canImportTasks = useCanImportTasks();
  return /*#__PURE__*/_jsxs(UIHeader, {
    title: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crm-tasks-ui.pageTitles.tasksHome"
        })
      }), /*#__PURE__*/_jsx(HeaderRecordCount, {})]
    }),
    titleControls: isUngatedForLegacyBoard && /*#__PURE__*/_jsx(TableBoardIconSwitcher, {
      pageId: pageId
    }),
    tabs: /*#__PURE__*/_jsx(UIFlex, {
      children: tabs
    }),
    children: [isJitaUser && /*#__PURE__*/_jsx(JitaUserArea, {}), !isBoard && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UIRouterButton, {
        "data-selenium-test": "manage-queues-button",
        size: "small",
        to: getQueuesLink(),
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "manageQueuesPanel.manageQueuesButtonLabel"
        })
      }), /*#__PURE__*/_jsx(UITooltip, {
        disabled: canImportTasks,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "importTasksDisabledTooltip"
        }),
        children: /*#__PURE__*/_jsx(UIButton, {
          disabled: !canImportTasks,
          href: getImportLink(),
          size: "small",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "importTasksButtonLabel"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(CreateTaskButton, {
      size: "small",
      use: "primary"
    })]
  });
}